import { render } from "./OpcaoUnica.vue?vue&type=template&id=daa63682"
import script from "./OpcaoUnica.vue?vue&type=script&lang=js"
export * from "./OpcaoUnica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__